import axios from 'axios'
import {API_URL} from './data'

export async function post(apiName: string, data = {}) {
  const url = `${API_URL}${apiName}`
  return axios
    .post(url, data)
    .then(function (response) {
      return response
    })
    .catch(function (error) {
      return error.response
    })
}

export async function put(apiName: string, data = {}) {
  const url = `${API_URL}${apiName}`
  return axios
    .put(url, data)
    .then(function (response) {
      return response
    })
    .catch(function (error) {
      return error.response
    })
}

export async function get(apiName: string) {
  const url = `${API_URL}${apiName}`

  return axios
    .get(url)
    .then(function (response) {
      return response
    })
    .catch(function (error) {
      return error.response
    })
}

export async function Delete(apiName: string, id: string | number | null) {
  const url = `${API_URL}${apiName}${id ? '/' + id : ''}`

  return axios
    .delete(url)
    .then(function (response) {
      return response
    })
    .catch(function (error) {
      return error.response
    })
}
export async function update(apiName: string, id: string | number, data: any) {
  const url = `${API_URL}${apiName}/${id}`
  return axios
    .patch(url, data)
    .then(function (response) {
      return response
    })
    .catch(function (error) {
      return error.response
    })
}

export async function patch(apiName: string, id: string, data = {}) {
  const url = id === '' ? `${API_URL}${apiName}` : `${API_URL}${apiName}/${id}`
  return axios
    .patch(url, data)
    .then(function (response) {
      return response
    })
    .catch(function (error) {
      return error.response
    })
}